import Dialpad from "./Dialpad";
import Stopper from 'assets/images/stopper.png';
import './index.scss';
import { useTheme } from "@emotion/react";

function DialPad({ setInput }) {
  const dialpadHandler = (e) => {
    setInput(`${e}`)
  }
  const theme = useTheme();

  return (
    <div className="dial-wrapper">
      <div className="dial-container">
        <Dialpad
          canvasSize={350}
          circlesFillColor={"#555555"}
          circlesStrokeColor={"black"}
          circlesHighlighFillColor={"black"}
          discFillColor={"#55555500"}
          discStrokeColor={"black"}
          circlesHighlightStrokeColor={"black"}
          circlesHighlightFillColor={theme.palette.primary.main}
          circlesHighlightTextColor={theme.palette.bareColors.main}
          // textFillColor={"white"}
          // textStrokeColor={"black"}
          // arrowFillColor={"black"}
          // arrowStrokeColor={"black"}
          callback={dialpadHandler}
        ></Dialpad>
      </div>
      <img src={Stopper} alt="Stopper" className="stopper" id="stopper" />
    </div>
  );
}

export default DialPad;